import {DynamicTable} from '../../../../components/DynamicTable'
import PaymentDetailsTableRow from './PaymentDetailsTableRow'
import {formatPrice} from '../../../../utils/common'
import { parseDateDetails } from '../../parsings'
import { PaymentCalendarSortableColumns } from '../../utils/config'
import {useContext} from 'react'
import {PaymentCalenderPageContext} from '../../contexts'
import {useGetDateDetails} from '../../hooks/useGetDateDetails'


const PaymentDetailsTable = () => {
  const {selectedDate} = useContext(PaymentCalenderPageContext)
  const {filters: eventFilters} = useContext(PaymentCalenderPageContext)
  const {selectedDateDetails, isLoadingDateDetails, filters, onSortingChange} = useGetDateDetails(
    selectedDate,
    eventFilters.store_filter,
    eventFilters.supplier_filter
  )

  return (
    <DynamicTable
      data={selectedDateDetails}
      sortableColumns={PaymentCalendarSortableColumns}
      onSortingChange={onSortingChange}
      filters={filters}
      TableRow={PaymentDetailsTableRow}
      tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-3'
      tableHeaderClass='fw-bold text-muted'
      rowParsingFunction={parseDateDetails}
      loading={isLoadingDateDetails}
      tableFooter={({columnTotals}: any) => {
        return (
          <tfoot>
            <tr className='fw-bold'>
              <td colSpan={4}>
                <strong>Total:</strong>
              </td>
              <td className='text-end'>
                <strong>
                  {columnTotals.make_payment ? formatPrice(columnTotals.make_payment, false) : '-'}
                </strong>
              </td>
              <td className='text-end'>
                <strong>
                  {columnTotals.total_amount ? formatPrice(columnTotals.total_amount, false) : '-'}
                </strong>
              </td>
              <td className='text-end'>
                <strong>
                  {columnTotals.paid_amount ? formatPrice(columnTotals.paid_amount, false) : '-'}
                </strong>
              </td>
              <td className='text-end'>
                <strong>
                  {columnTotals.remaining_amount
                    ? formatPrice(columnTotals.remaining_amount, false)
                    : '-'}
                </strong>
              </td>
            </tr>
          </tfoot>
        )
      }}
    />
  )
}

export default PaymentDetailsTable
